import * as React from 'react'

function IconLoading(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={87}
      height={86}
      viewBox="0 0 87 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.518 56.857c7.727 13.953 25.302 19 39.255 11.273 13.953-7.726 19-25.302 11.274-39.255-7.727-13.953-25.302-19-39.256-11.274"
        stroke="#DDEBF4"
        strokeOpacity={0.5}
        strokeWidth={12}
        strokeLinecap="round"
      />
      <path
        d="M35.91 14.812c-15.407 4.128-24.55 19.964-20.422 35.37 4.128 15.407 19.964 24.55 35.37 20.421 15.407-4.128 24.55-19.963 20.422-35.37"
        stroke="#1978B2"
        strokeWidth={12}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconLoading
